(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('ScheduleTestController', ScheduleTestController);
    ScheduleTestController.$inject = ['$uibModalInstance','VirtualFairService','AdmService', '$uibModal','$scope','representative'];

    function ScheduleTestController($uibModalInstance,VirtualFairService,AdmService, $uibModal,$scope,representative) {

        var vm              = this;
        vm.cancel           = cancel;
        vm.getSellers       = getSellers;
        vm.saveVirtualFairTest     = saveVirtualFairTest;
        vm.sellerSelected   = '';
        vm.representative   = representative;

        function cancel() {
            $uibModalInstance.close();
        }

        function active(){
            getSellers();
        }

        function getSellers() {
            AdmService.getSellers({}).then(function(response){
                vm.sellers = response.data;
            }).catch(function(err) {
            });
        }

        function saveVirtualFairTest() {

            vm.query = {};
            vm.query['admin_user_id']               = vm.sellerSelected.id;
            vm.query['expo_user_virtual_fair_id']   = vm.representative.expo_user_virtual_fair_id;
            vm.query['expo_user_virtual_fair_representative_id'] = vm.representative.id;
            vm.query['start'] = convertToUTC(new Date(vm.dateRangeStart));
            vm.query['end'] = convertToUTC(new Date(vm.dateRangeEnd));
            vm.query['timezone']                    = new Date(vm.dateRangeEnd);
            VirtualFairService.storeTest(vm.query).then(function(response){
                if(Object.keys(representative.tests).length === 0)
                {
                    representative.tests = {};
                }
                representative.tests[response.id] = {'id' : response.id, 'schedule' : response.schedule, 'seller' : response.seller };
                $uibModalInstance.close();
            }).catch(function(err) {
            });
        }
        vm.convertToUTC = convertToUTC;
        function convertToUTC(date)
        {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        }

        /* Bindable functions
         -----------------------------------------------*/
        vm.endDateBeforeRender = endDateBeforeRender;
        vm.endDateOnSetTime = endDateOnSetTime;
        vm.startDateBeforeRender = startDateBeforeRender;
        vm.startDateOnSetTime = startDateOnSetTime;

        function startDateOnSetTime () {
            $scope.$broadcast('start-date-changed');
        }

        function endDateOnSetTime () {
            $scope.$broadcast('end-date-changed');
        }

        function startDateBeforeRender ($dates) {
            if (vm.dateRangeEnd) {
                var activeDate = moment(vm.dateRangeEnd);

                $dates.filter(function (date) {
                    return date.localDateValue() >= activeDate.valueOf();
                }).forEach(function (date) {
                    date.selectable = false;
                });
            }
        }

        function endDateBeforeRender ($view, $dates) {
            if (vm.dateRangeStart) {
                //vm.startDate = vm.dateRangeStart.format('DD/MMM/YYYY h:mm');
                var activeDate = moment(vm.dateRangeStart).subtract(1, $view).add(1, 'minute');

                $dates.filter(function (date) {
                    return date.localDateValue() <= activeDate.valueOf();
                }).forEach(function (date) {
                    date.selectable = false;
                });
            }
        }

        active();

    }

})();